import { render } from "./FoodForThought.vue?vue&type=template&id=42ddc69b&scoped=true"
import script from "./FoodForThought.vue?vue&type=script&lang=js"
export * from "./FoodForThought.vue?vue&type=script&lang=js"

import "./FoodForThought.vue?vue&type=style&index=0&id=42ddc69b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ddc69b"]])

export default __exports__